(() => {
  const register = (name, initializer) => {
    if (window.SafeWalkV51Product?.register) window.SafeWalkV51Product.register(name, initializer);
    else (window.SafeWalkV51ProductQueue ||= []).push([name, initializer]);
  };

  register('sip-paw-purchase', ({ root, listen }) => {
    const variantsNode = root.querySelector('[data-swv5-variants]');
    const idInput = root.querySelector('[data-variant-id]');
    if (!variantsNode || !idInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      variants = [];
    }
    if (!Array.isArray(variants)) variants = [];

    const currency = root.dataset.currency || 'ILS';
    const money = (cents) => {
      const amount = Number(cents || 0);
      const decimals = Math.abs(amount) % 100 === 0 ? 0 : 2;
      try {
        return new Intl.NumberFormat('he-IL', {
          style: 'currency',
          currency,
          minimumFractionDigits: decimals,
          maximumFractionDigits: 2
        }).format(amount / 100).replace(/\s/g, ' ');
      } catch (error) {
        return `₪${(amount / 100).toFixed(decimals)}`;
      }
    };

    const selectedOptions = () => Array.from(root.querySelectorAll('.swv5-option')).map((option) => {
      return option.querySelector('[data-option-value]:checked')?.value || '';
    });
    const findVariant = () => {
      const selected = selectedOptions();
      if (selected.length === 0) return variants.find((variant) => String(variant.id) === idInput.value) || variants[0];
      return variants.find((variant) => variant.options?.every((value, index) => value === selected[index]));
    };
    const updatePrice = (variant) => {
      root.querySelectorAll('[data-fp-product-price]').forEach((price) => {
        const current = price.querySelector('[data-fp-product-current]');
        const compare = price.querySelector('[data-fp-product-compare]');
        const badge = price.querySelector('[data-fp-product-sale]');
        const compareCents = Number(variant.compare_at_price || 0);
        const priceCents = Number(variant.price || 0);
        const percent = compareCents > priceCents ? Math.floor(((compareCents - priceCents) * 100) / compareCents) : 0;
        if (current) current.textContent = money(priceCents);
        if (compare) {
          compare.textContent = money(compareCents || priceCents);
          compare.hidden = price.dataset.showComparePrice !== 'true' || compareCents <= priceCents;
        }
        if (badge) {
          badge.textContent = (price.dataset.saleBadgeTemplate || '[percent]%').replace('[percent]', percent);
          badge.hidden = price.dataset.showSaleBadge !== 'true' || percent <= 0;
        }
      });
    };
    const update = (colorChanged = false) => {
      root.querySelectorAll('.swv5-option').forEach((option) => {
        const checked = option.querySelector('[data-option-value]:checked');
        const label = option.querySelector('[data-selected-option]');
        if (checked && label) label.textContent = checked.value;
      });
      const variant = findVariant();
      if (!variant) return;
      idInput.value = String(variant.id);
      root.dataset.currentVariantId = String(variant.id);
      updatePrice(variant);
      root.querySelectorAll('[data-atc-price], [data-mobile-price], [data-desktop-price]').forEach((node) => {
        node.textContent = money(variant.price);
      });
      root.querySelectorAll('[data-atc], [data-swv5-submit]').forEach((button) => {
        button.disabled = !variant.available;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('swv5:variant-change', {
        bubbles: true,
        detail: { variant, colorChanged, colorMediaId: variant.featured_media?.id || '' }
      }));
    };

    root.querySelectorAll('[data-option-value]').forEach((control) => {
      listen(control, 'change', () => update(control.closest('.swv5-option')?.classList.contains('swv5-option--color')));
    });
    update(false);
  });
})();
